import { defineMessages } from 'react-intl'

export const JobDetailsContactMessages = defineMessages({
  title: {
    id: 'JobDetailsContact.title',
    description: 'Title for Details/Contact block on JobInfo page',
    defaultMessage: 'Contact',
  },
  nameField: {
    id: 'JobDetailsContact.nameField',
    description: 'Name field label for contacts form on JobInfo page',
    defaultMessage: 'Name',
  },
  roleField: {
    id: 'JobDetailsContact.roleField',
    description: 'Role field label for contacts form on JobInfo page',
    defaultMessage: 'Role',
  },
  phoneField: {
    id: 'JobDetailsContact.phoneField',
    description: 'Phone field label for contacts form on JobInfo page',
    defaultMessage: 'Phone',
  },
  emailField: {
    id: 'JobDetailsContact.emailField',
    description: 'Email field label for contacts form on JobInfo page',
    defaultMessage: 'Email',
  },
})
